import { Fragment } from "react";
import Landscape from "./landscape";
import Portrait from "./portrait";
import classes from "../styles/Bars.module.css";
import { getClasses } from "../utils";
import { useAppSelector } from "../hooks";

const Bars: React.FC = (props) => {
  const layout = useAppSelector(
    (state) => state.layout,
    (o, n) => o.name === n.name
  );

  let elements;
  if (layout.name === "landscape") {
    elements = (
      <Fragment>
        <Landscape.Topbar> </Landscape.Topbar>
        <Landscape.ButtonsBar></Landscape.ButtonsBar>
        <Landscape.BottomBar></Landscape.BottomBar>
      </Fragment>
    );
  } else {
    elements = (
      <Fragment>
        <Portrait.Topbar></Portrait.Topbar>
        <Portrait.ControlsBar></Portrait.ControlsBar>
        <Portrait.ButtonsBar></Portrait.ButtonsBar>
        <Portrait.BottomBar></Portrait.BottomBar>
      </Fragment>
    );
  }

  return (
    <div className={getClasses(classes, "bars")}>
      {elements}
      {props.children}
    </div>
  );
};

export default Bars;
